<form [formGroup]="supplierForm" class="contact-form">
  <div class="form-section">
    <div class="form-item two-col form-section">
      <div class="form-item two-col">
        <label for="company-name">
          * {{
            "CARRIERDB.NEW_CARRIER_FORM.COMPANY_NAME"
              | translate : locale.language
          }}</label
        >
        <input
          pInputText
          id="company-name"
          formControlName="companyName"
        />
      </div>

      <div class="form-item two-col">
        <label for="email">
          * {{
            "CARRIERDB.NEW_CARRIER_FORM.EMAIL" | translate : locale.language
          }}</label
        >
        <input
          pInputText
          id="email"
          aria-describedby="email"
          formControlName="emailAddress"
        />
      </div>
      <div class="form-item two-col">
        <label for="website">
          {{
            "CARRIERDB.NEW_CARRIER_FORM.WEBSITE" | translate : locale.language
          }}</label
        >
        <input pInputText id="website" formControlName="website" />
      </div>
    </div>
    <div class="form-item two-col">
      <div class="img-container">
        <div>
          <p-image
            [src]="logoSrc ?? defaultLogoSrc"
            alt="Image"
            height="100%"
          />
        </div>
      </div>
      <div class="img-button-container">
        <p-button
          label="{{
            'CARRIERDB.NEW_CARRIER_FORM.BTN_DELETE_LOGO'
              | translate : locale.language
          }}"
          severity="secondary"
          (onClick)="onLogoReset()"
        ></p-button>
        <p-fileUpload
          maxFileSize="1000000"
          accept="image/*"
          [files]="logo"
          [multiple]="false"
          [customUpload]="true"
          [showUploadButton]="false"
          [showCancelButton]="true"
          mode="basic"
          chooseLabel="{{
            'CARRIERDB.NEW_CARRIER_FORM.BTN_ADD_LOGO'
              | translate : locale.language
          }}"
          (onSelect)="onSelect($event)"
          (onRemove)="onLogoReset()"
          (onClear)="onLogoReset()"
        >
        </p-fileUpload>
      </div>
    </div>

    <div class="form-item two-col">
      <label for="contact-first-name">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.COMPANY_CONTACT_FIRST_NAME"
            | translate : locale.language
        }}</label
      >
      <input
        pInputText
        id="contact-first-name"
        formControlName="representativeFirstName"
      />
    </div>
    <div class="form-item two-col">
      <label for="contact-last-name">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.COMPANY_CONTACT_LAST_NAME"
            | translate : locale.language
        }}</label
      >
      <input
        pInputText
        id="contact-last-name"
        formControlName="representativeLastName"
      />
    </div>

    <div class="form-item two-col">
      <label for="telephone">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.TELEPHONE" | translate : locale.language
        }}</label
      >
      <input pInputText id="telephone" formControlName="phoneNumber" />
    </div>
    <div class="form-item two-col">
      <label for="mobile">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.MOBILE" | translate : locale.language
        }}</label
      >
      <input pInputText id="mobile" formControlName="mobileNumber" />
    </div>
    <div class="form-item four-col">
      <div class="flex gap-2">
        <label for="cover-adr">
          {{
            "CARRIERDB.NEW_CARRIER_FORM.COVER_ADR" | translate : locale.language
          }}
        </label>
        <p-checkbox
          formControlName="coverADR"
          binary="true"
          inputId="cover-adr"
          id="cover-adr"
        />
      </div>
    </div>
  </div>
  <p-divider>
    <b>
      {{ "CARRIERDB.NEW_CARRIER_FORM.ADDRESS" | translate : locale.language }}
    </b>
  </p-divider>
  <div class="form-section">
    <div class="form-item three-col">
      <label for="street">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.STREET" | translate : locale.language
        }}</label
      >
      <input pInputText id="street" formControlName="street" />
    </div>
    <div class="form-item">
      <label for="postal-code">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.POSTAL_CODE" | translate : locale.language
        }}</label
      >
      <input
        pInputText
        id="postal-code"
        formControlName="postalCode"
      />
    </div>
    <div class="form-item two-col">
      <label for="city">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.CITY" | translate : locale.language
        }}</label
      >
      <input pInputText id="city" formControlName="city" />
    </div>
    <div class="form-item two-col">
      <label for="country">
        * {{
          "CARRIERDB.NEW_CARRIER_FORM.COUNTRY" | translate : locale.language
        }}</label
      >
      <p-dropdown
        id="country"
        formControlName="country"
        [options]="countryData"
        optionLabel="name"
        optionValue="code"
        [showClear]="true"
        placeholder="{{
          'CARRIERDB.PLACEHOLDER.LOCATIONS' | translate : locale.language
        }}"
      />
    </div>
  </div>
  <p-divider>
    <b>
      Green Factor
      {{ "CARRIERDB.INFORMATION" | translate : locale.language }}
    </b>
  </p-divider>
  <div class="info-text">
    <span>{{"CARRIERDB.NEW_CARRIER_FORM.GREEN_FACTOR_INFO_TXT" | translate:locale.language}}</span> <br/>
    <span class="info-hint">{{"CARRIERDB.NEW_CARRIER_FORM.GREEN_FACTOR_INFO_HNT" | translate:locale.language}}</span>
  </div>
  <div class="form-section">
    <div class="form-item two-col">
      <label for="co2-score">
        <i  class="fas fa-info-circle" 
            pTooltip="{{
              ('CARRIERDB.NEW_CARRIER_FORM.CO2_SCORE_HNT_1' | translate:locale.language) + '\n' +
              ('CARRIERDB.NEW_CARRIER_FORM.CO2_SCORE_HNT_2' | translate:locale.language)
            }}">
        </i>
        {{ "CARRIERDB.NEW_CARRIER_FORM.CO2_SCORE" | translate : locale.language }}
      </label>
      <p-inputNumber  pInputText id="co2-score" 
                      formControlName="co2Score" 
                      [min]="0"/>
    </div>
    <div class="form-item two-col">
      <label for="total-co2-emission">
        <i  class="fas fa-info-circle" 
            pTooltip="{{
              ('CARRIERDB.NEW_CARRIER_FORM.TOTAL_CO2_EMISSION_HNT_1' | translate:locale.language) + '\n' +
              ('CARRIERDB.NEW_CARRIER_FORM.TOTAL_CO2_EMISSION_HNT_2' | translate:locale.language)
            }}">
        </i>
        {{"CARRIERDB.NEW_CARRIER_FORM.TOTAL_CO2_EMISSION" | translate : locale.language }} 
      </label >
      <p-inputNumber 
        pInputText
        id="total-co2-emission"
        formControlName="co2EmissionTotal"
        [min]="0"
      />
    </div>
    <div class="form-item two-col">
      <label for="score-platform">
        <i  class="fas fa-info-circle" 
            pTooltip="{{
              'CARRIERDB.NEW_CARRIER_FORM.SCORE_PLATFORM_HNT' | translate:locale.language
            }}">
        </i>
        {{"CARRIERDB.NEW_CARRIER_FORM.SCORE_PLATFORM" | translate : locale.language }}
      </label >
      <input
        pInputText
        id="score-platform"
        formControlName="scorePlatform"
      />
    </div>
    <div class="form-item two-col">
      <label for="score-platform-link">
        <i  class="fas fa-info-circle" 
            pTooltip="{{
              'CARRIERDB.NEW_CARRIER_FORM.SCORE_PLATFORM_LINK_HNT' | translate:locale.language
            }}">
        </i>
        {{"CARRIERDB.NEW_CARRIER_FORM.SCORE_PLATFORM" | translate : locale.language }} Link 
      </label >
      <input
        pInputText
        id="score-platform-link"
        formControlName="scorePlatformLink"
      />
    </div>
  </div>
</form>
